<template>
    <footer class="w-full bg-nomad-900 border-t border-nomad-800 mt-16 mb-30" role="contentinfo">
        <div class="max-w-6xl mx-auto px-6 py-12">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                <!-- About -->
                <div class="space-y-3">
                    <h3 class="text-white font-bold text-lg">Heesify</h3>
                    <p class="text-nomad-300 text-sm font-light">Your home for Somali music, podcasts, and stories.
                    </p>
                </div>

                <!-- Quick Links -->
                <div class="space-y-3">
                    <h3 class="text-white font-bold text-lg">More</h3>
                    <ul class="space-y-2">
                        <li>
                            <a href="/pages/apps" target="_blank"
                                class="text-nomad-300 hover:text-nomad-accent transition-colors text-sm">
                                Download Apps
                            </a>
                        </li>
                        <li>
                            <a href="https://status.nomadlyrics.com/" target="_blank"
                                class="text-nomad-300 hover:text-nomad-accent transition-colors text-sm">
                                Service Status
                            </a>
                        </li>
                        <li>
                            <a href="https://forms.gle/JJXLnjQDuzdkYg5w8" target="_blank"
                                class="text-nomad-300 hover:text-nomad-accent transition-colors text-sm">
                                Upload Music
                            </a>
                        </li>
                    </ul>
                </div>

                <!-- Built By -->
                <div class="space-y-3">
                    <h3 class="text-white font-bold text-lg">Built By</h3>
                    <a href="https://nexainteractives.com" target="_blank"
                        class="inline-flex items-center gap-2 text-nomad-accent hover:text-nomad-accent/80 font-semibold transition-colors text-sm">
                        Nexa Interactives
                        <span class="icon-external-link text-xs"></span>
                    </a>
                    <hr class="w-8 border-b-1 border-nomad-600">
                    <ul>
                        <li>
                            <a href="/pages/privacy-policy" target="_blank"
                                class="text-nomad-300 hover:text-nomad-accent transition-colors text-sm">
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a href="/pages/terms" target="_blank"
                                class="text-nomad-300 hover:text-nomad-accent transition-colors text-sm">
                                Terms of Service
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Bottom -->
            <div class="border-t border-nomad-800 pt-6 text-center">
                <p class="text-nomad-300 text-sm font-light flex items-center justify-center gap-2">
                    Made with
                    <span
                        class="icon-heart text-nomad-accent hover:scale-125 transition-transform cursor-default"></span>
                    &copy; 2025 Heesify
                </p>
            </div>
        </div>
    </footer>
</template>
